export enum ESpecialEventsClasses {
    tech = 'tech',
    rec = 'rec',
}
